export enum MicrosoftModels {
  PHI = "phi", //phi 2
  PHI3_MINI = "phi3:mini",
  PHI3_MEDIUM = "phi3:medium",
  PHI3_5 = "phi-3.5",
  PHI4 = "phi4",
}

export const MicrosoftModelsEnabled = [MicrosoftModels.PHI3_MINI, MicrosoftModels.PHI3_MEDIUM]
